/* eslint-disable jsx-a11y/no-onchange */
import cn from 'classnames';
import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

export interface Props
  extends Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'onChange'
  > {
  value: number;
  minValue?: number;
  onChange: (newValue: number) => void;
  hideLabel?: boolean;
}

const AmountInput: React.FC<Props> = ({
  minValue = 0,
  value,
  onChange,
  className,
  hideLabel = false,
}) => {
  // @Note : Remove optimistic update for now as it doesn't get rendered well with SWR-hooked use-Effective cart implementation
  // const [internalValue, setIntervalValue] = useState(value || minValue);

  // on some cases, props updates in the parent components are not propagated properly.
  // needs to optimization.
  // useEffect(() => {
  //   setIntervalValue(value);
  // }, [value]);

  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  return (
    <div className={cn('relative inline-block w-14 lg:mt-0')}>
      {!hideLabel && (
        <label htmlFor="amountSelect" className="text-xs font-black uppercase lg:hidden">
          <FormattedMessage id="common:product:quantity" />
        </label>
      )}
      <select
        id="amountSelect"
        value={value || minValue}
        onChange={(e) => {
          // optimistic update
          // setIntervalValue(parseInt(e.target.value));
          onChange(parseInt(e.target.value));
        }}
        onClick={(e) => {
          // Prevents further propagation of the click event while clicking on the quantity selector in the product card on the cart page.
          // The behaviour of this card is to open the PDP in a new tab.
          // Change requested withe https://petsdeli.atlassian.net/browse/PT-2760
          e.stopPropagation();
        }}
        className={cn(
          'border-grey-900 bg-background-default hover:border-grey-500 lg:border-grey-400 lg:bg-other-white block w-full appearance-none rounded-lg border px-2 pt-2 pr-4 pb-1 text-base leading-tight shadow-sm focus:ring-3 focus:outline-hidden lg:rounded-sm',
          className
        )}
      >
        {Array.from({ length: 100 }, (value, index) => (
          <option key={index} value={index}>
            {index}
          </option>
        ))}
      </select>
      <div className="text-grey-700 pointer-events-none absolute inset-y-0 right-0 flex items-center justify-center pr-2">
        <svg
          className="h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  );
};

export default AmountInput;
